var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "app-menu",
        {
          attrs: { menuItems: _vm.menuItems },
          on: {
            action: function($event) {
              return _vm.$emit("action", $event)
            }
          },
          scopedSlots: _vm._u([
            {
              key: "before",
              fn: function() {
                return [
                  _c("div", { staticClass: "user-search" }, [
                    _c(
                      "a",
                      {
                        staticClass: "search",
                        attrs: { href: "" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            _vm.searchOpen = !_vm.searchOpen
                          }
                        }
                      },
                      [_vm._v("Search")]
                    )
                  ])
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _vm._v(" "),
          true || _vm.$parent.$parent.loggedIn
            ? _c("div", { staticClass: "user-cart" }, [
                _c(
                  "a",
                  {
                    staticClass: "cart",
                    attrs: { href: "" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        _vm.cartOpen = !_vm.cartOpen
                      }
                    }
                  },
                  [
                    _vm._v("Cart\n        "),
                    _vm.cart.cartItems && _vm.cart.cartItems.length
                      ? _c("span", [_vm._v(_vm._s(_vm.cart.cartItems.length))])
                      : _vm._e()
                  ]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "user-controls" }, [
            !_vm.$parent.$parent.loggedIn
              ? _c("div", { staticClass: "out" }, [
                  _c(
                    "a",
                    {
                      staticClass: "navlink",
                      attrs: { href: "" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.actionRegister($event)
                        }
                      }
                    },
                    [_vm._v("Register")]
                  ),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "navlink",
                      attrs: { href: "" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.actionLogin($event)
                        }
                      }
                    },
                    [_vm._v("Login")]
                  )
                ])
              : _c(
                  "div",
                  { staticClass: "in" },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "navlink",
                        attrs: { href: "" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.actionProfile($event)
                          }
                        }
                      },
                      [_vm._v("Profile")]
                    ),
                    _vm._v(" "),
                    _vm.isAdmin
                      ? _c(
                          "router-link",
                          {
                            staticClass: "navlink navadmin",
                            attrs: { to: { name: "admin.posts" } }
                          },
                          [_vm._v("Admin")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "navlink",
                        attrs: { href: "" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.actionLogout($event)
                          }
                        }
                      },
                      [_vm._v("Logout")]
                    )
                  ],
                  1
                )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pop-pane pop-pane-center" },
        [
          _c(
            "transition",
            { attrs: { name: "pop-pane" } },
            [
              _vm.currentPane == "register"
                ? _c("user-register", { staticClass: "register" })
                : _vm.currentPane == "login"
                ? _c("user-login", { staticClass: "login" })
                : _vm.currentPane == "profile"
                ? _c("user-profile", { staticClass: "profile" })
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pop-pane pop-pane-right" },
        [
          _c(
            "transition",
            { attrs: { name: "pop-pane" } },
            [
              _c("cart", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.cartOpen,
                    expression: "cartOpen"
                  }
                ]
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pop-pane pop-pane-left" },
        [
          _c(
            "transition",
            { attrs: { name: "pop-pane" } },
            [
              _c("search", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.searchOpen,
                    expression: "searchOpen"
                  }
                ]
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }